<template>
    <q-dialog v-model="confirm" ref="dialog" persistent>
        <q-card>
            <q-card-section class="bg-primary text-white text-center">
                <div class="text-h6">How to use Te Koinga</div>
            </q-card-section>
    
            <q-card-section v-if="loading" class="align-center" style="margin-left: 45%">
                <q-spinner color="primary" size="3em" :thickness="5" />
            </q-card-section>
    
    
            <q-form @submit.prevent="submitFeedback">
                <q-card-section class="row items-center feedback-inputs">
                    <div>
                        <h3 class="text-center">Overview</h3>
                        <p>
                            This is a brief explanation of our web app Te Koinga, what it can do, and how to use it. The purpose of Te Koinga is to display data(that is being pulled from paua) in a way that is more easily accessible and visually appealing. The main areas that will be used are ‘Data’, and ‘Teams’.
                        </p>
                    </div>
                    <div>
                        <h3 class="text-center">Data</h3>
                        <h4 class="text-left">Map</h4>
                        <p>
                            The map is going to be a heat map which will display data of New Zealand and where the clients of Purapura Whetu are placed. The map will be from a lighter colour through to a darker colour, the lighter colour dependent on the filter will show the smaller percentage/population where as the darker colours will show the larger percentage/population.
                            The map is going to be able to be filtered by different categories but will ultimately have a how to use on the website as well as a step by step guide on the web page itself.
                            The step guide will be as follows:
                        </p>
                        <ul>
                            <li>Step 1: Select filter</li>
                            <li>Step 2: Select client type via service (optional)</li>
                            <li>Step 3:Summary</li>
                        </ul>
                        <p>
                            Each filter and section will have a little description when you hover it.
                            Each area on the map is going to be clickable and will showcase relevant data in that area dependent on which filter you have clicked on.
                        </p>
                        <h4 class="text-left">Data Graphs</h4>
                        <p>
                            With the heat map there will be areas that need to be drilled in a bit more so we have created a page of a different set of graphs which are split up into demographics, activity, and flow. All current graphs being displayed are what will be offered but doesn’t mean more can’t be added later. 
                            Each section will have filters that will be able to be applied to every graph the filters will be as followed:
                        </p>
                        <ul>
                            <li>Filter by Service</li>
                            <li>Filter by Program</li>
                            <li>Filter by Age Ragne</li>
                            <li>Filter by Gender</li>
                            <li>Filter by Ethnicity</li>
                        </ul>
                        <p>
                            As well as each section having the filters, there will be a export button which will take the information of each section and make it into a csv file which is downloadable. Client flow will have the export button inside the waitlist table.
                        </p>
                        <h5 class="text-left">Client Demographics</h5>
                        <p>Demographics is broken up into 4 graphs as follows</p>
                        <ul>
                            <li>Top 10 clients by iwi and other</li>
                            <li>Active clients by age</li>
                            <li>Active clients by gender</li>
                            <li>Top 10 ethnicities and other</li>
                        </ul>
                        <h5 class="text-left">Client Activity</h5>
                        <p>
                            Client activity focuses on the engagement towards the services or the organization itself made of 4 graphs:
                        </p>
                        <ul>
                            <li>Top 10 Referral sources of All Time</li>
                            <li>Hours spent engaged via groups(active clients)</li>
                            <li>Hours spent engaged via 1 on 1(active clients)</li>
                            <li>Time since last interaction</li>
                        </ul>
                        <h5 class="text-left">Client Flow</h5>
                        <p>
                            At the moment client flow doesn’t have too much data displayed on graphs but they have the 2 graphs as follow:
                        </p>
                        <ul>
                            <li>Client entry and exit data</li>
                            <li>Time spent on waitlist(active clients)</li>                            
                        </ul>                    
                        <p>
                            Underneath the waitlist graph will be a view current waitlist button which will bring up a current table that shows all people who are currently on the waitlist.
                        </p>
                    </div>
                    <div>
                        <h4 class="text-center">Teams</h4>
                        <h5 class="text-left">Dashboard</h5>
                        <p>
                            Currently the team’s dashboard has minimal information but this will be a more in depth data area for teams that will showcase data and graphs tailored to teams rather than the data tailored to clients.
                            This will also be a place to store important documents for kaimahi to read and kaimahi will be able to store their favorite links or information.
                        </p>
                        <h5 class="text-left">Profile</h5>
                        <p>
                            The profile section allows staff members to have a page for customizable personal information. When a staff member logs into the web application using Microsoft Single Sign On, we use the information stored within our database to validate the staff. The information used to validate is retrieved from Paua, and ideally shouldn’t be changed. Therefore, to allow for customizable staff information, we have created another table. This will allow staff members to change any information they want displayed on the web app to other staff members – contact hours, contact information. This information is only available through the web application.
                        </p>
                        <h5 class="text-left">Secondary Data</h5>
                        <p>
                            Most information collected from Purapura clients can be directly entered into Paua using the forms available on Pauas website. However, there are additional forms within Purapura that do not have a corresponding entry point available in Paua. The Secondary Data form allows for capturing data that is not able to be entered into other Purapura Whetu services, and for capturing data pertaining to tangata who are not in the Paua database.
                            There is an additional tab on this page to view the responses and generate reports. 
                        </p>
                    </div>
                </q-card-section>
    
                <q-card-actions align="center">
                    <q-btn flat label="Close" color="primary" v-close-popup />
                </q-card-actions>
            </q-form>
        </q-card>
    </q-dialog>
</template>

<script>

import api from "../../services/api/api";
import notify from '@/services/util/notify';


export default { 
name: "FeedbackModal",
data: () => ({
    
    modalInstance: null,
    feedbackType: '',
    feedback: null,
    isAnonymous: null, 
    loading: false,

    confirm: false,

    options: [
        'Feedback About App',
        'General Purapura Whetu Feedback',
        'Tech Tip Suggestion'
    ],

    close: 0,

    }),


    watch: {

        showModal(newValue ) {
            if (newValue === true) {
            this.modalActive();
            }
        },

    },
    methods: {


        show() {
            console.log("SHOWING")
            this.$refs.dialog.show();
        },

        hide() {
            console.log("HIDING")
            this.$refs.dialog.hide();
        },

        onCancelClick() {
            this.hide();
        },


        /**
         * Submits a feedback response
         */
        submitFeedback() {
            this.loading = true

            let feedback_object =  {
                subject: this.feedbackType,
                message: this.feedback,
                staff_id: sessionStorage.getItem("staffId")
            }


            api.forms
                .uploadFeedbackResponse(feedback_object).then(res => {
                    console.log(res)
                    this.loading = false,
                    this.hide()
                }).catch(() =>{
                    this.loading = false,
                    notify.error('Error: Failed to submit response', 'top');
                })
        }
    }
};
</script>

<style scoped>
@import '../../assets/styles/modal.css';

</style>